<template>

  <div>
    <b-row
      class="content-header"
      style="flex-wrap: nowrap;"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        md="10"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h3 class="custom-header-title d-md-none d-block float-left pr-1 mb-0">
              Workflow Category
            </h3>
            <h1 class="custom-header-title d-md-block d-none float-left pr-1 mb-0">
              Workflow Category
            </h1>
          </b-col>
        </b-row>
      </b-col>

      <!-- Content Right -->
      <b-col
        class="content-header-right text-md-right mb-1"
        md="2"
      >
        <b-button
          v-if="canViewThisAction('create', 'WorkFlowCategory')"
          variant="success"
          :to="{ name: 'operation-workflow-category-create' }"
        >
          <feather-icon
            icon="PlusIcon"
            class="mr-50"
            size="16"
          />
          <span class="align-middle d-md-block d-none">Create New Workflow Category</span>
          <span class="align-middle d-md-none d-block">New</span>
        </b-button>
      </b-col>
    </b-row>
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} - {{ dataMeta.to }} of {{ dataMeta.of }}</span>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <a
                href="javascript:void(0)"
                class="nav-link nav-link-search"
                @click="showSearchBar = !showSearchBar"
              >
                <feather-icon
                  icon="SearchIcon"
                  size="21"
                  class="mr-50"
                />
                <span class="align-middle">Search</span>
              </a>
              <b-input-group
                v-if="showSearchBar"
                class="input-group-merge mr-50"
              >
                <b-form-input
                  v-model="searchQuery"
                  placeholder="Search..."
                />
                <b-input-group-append is-text>
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer"
                    @click="searchQuery = ''; showSearchBar = !showSearchBar"
                  />
                </b-input-group-append>
              </b-input-group>
              <b-dropdown
                id="dropdown-Team-form"
                ref="filter_dropdown_workflow_category"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="dropdown-modal"
                right
                variant="link"
              >
                <template #button-content>
                  <feather-icon
                    icon="FilterIcon"
                    size="21"
                    class="align-middle mr-50"
                  />
                  <span class="mr-1">Filters</span>
                </template>
                <work-flow-category-filter
                  :status-filter.sync="statusFilter"
                  :status-radio-options="statusRadioOptions"
                  @emitHideFilter="hideFilter"
                  @emitShowFilter="showFilter"
                />
              </b-dropdown>
            </div>
          </b-col>
        </b-row>
        <div v-if="statusFilter">
          <hr class="dividerHR filter-divider">
          <b-row>

            <!-- Per Page -->
            <b-col
              cols="12"
              md="12"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <ul
                class="list-inline d-inline-block mb-1"
              >
                <li
                  v-if="statusFilter"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="statusFilter = null"
                  >
                    <span class="text-capitalize">{{ statusFilter }}</span>
                  </b-form-tag>
                </li>
                <li
                  class="list-inline-item"
                >
                  <span
                    class="text-danger clear-filter-text mb-50"
                    @click="clearAllFilters"
                  >
                    Clear Filters
                  </span>
                </li>
              </ul>
            </b-col>
          </b-row>
        </div>
      </div>

      <b-table
        ref="refWorkFlowCategoriesTable"
        class="position-relative"
        :items="fetchWorkFlowCategories"
        responsive
        :fields="tableColumns"
        primary-key="_id"
        :sort-by.sync="sortBy"
        show-empty
        no-sort-reset
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: Role -->
        <template #cell(stringID)="data">
          <div class="text-nowrap">
            <span class="text-bold-black">{{ data.item.stringID }}</span>
          </div>
        </template>

        <template #cell(workFlows)="data">
          <div class="demo-inline-spacing">
            <div class="text-nowrap">
              <span class="">{{ data.item.workFlows.length }}</span>
            </div>
          </div>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            :variant="`light-${resolveWorkFlowCategoryStatusVariant(data.item.status)}`"
            class="text-capitalize"
          >
            {{ data.item.status }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template
          v-if="canViewThisAction('update', 'WorkFlowCategory') || canViewThisAction('delete', 'WorkFlowCategory')"
          #cell(actions)="data"
        >
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <!-- <b-dropdown-item
              v-if="canViewThisAction('show', 'WorkFlowCategory')"
              :to="{ name: 'operation-workflow-category-show', params: { id: data.item._id } }"
            >
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50">View</span>
            </b-dropdown-item> -->

            <b-dropdown-item
              v-if="canViewThisAction('update', 'WorkFlowCategory')"
              :to="{ name: 'operation-workflow-category-edit', params: { id: data.item._id } }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('delete', 'WorkFlowCategory')"
              @click="deleteEntity(data.item._id)"
            >
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
    </b-card>

    <div
      v-if="totalWorkFlowCategories > perPage"
      class="mx-2 mb-2"
    >
      <b-row>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="12"
          class="d-flex align-items-center justify-content-center pagination-content"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="totalWorkFlowCategories"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            align="center"
            prev-text="Prev"
            next-text="Next"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
              <span>Prev</span>
            </template>
            <template #next-text>
              <span>Next</span>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BCard, BRow, BButton, BCol, BFormInput, BTable, BInputGroup, BInputGroupAppend,
  BBadge, BDropdown, BDropdownItem, BPagination, BFormTag,
} from 'bootstrap-vue'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
import useWorkFlowCategoriesList from './useWorkFlowCategoriesList'
import workFlowCategoryStoreModule from './workFlowCategoryStoreModule'
import WorkFlowCategoryFilter from './WorkFlowCategoryFilter.vue'
// import UserListAddNew from './UserListAddNew.vue'

export default {
  components: {
    // UserListAddNew,
    BFormTag,
    BCard,
    BRow,
    BButton,
    BCol,
    BFormInput,
    BTable,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroup,
    BInputGroupAppend,

    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,

    WorkFlowCategoryFilter,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      statusRadioOptions: [
        { text: 'Active', value: 'active' },
        { text: 'Inactive', value: 'inactive' },
      ],
    }
  },

  methods: {
    hideFilter() {
      this.$refs.filter_dropdown_workflow_category.hide(true)
    },
    showFilter() {
      this.$refs.filter_dropdown_workflow_category.show(true)
    },
    clearAllFilters() {
      this.statusFilter = null
    },
    deleteEntity(id) {
      this.$swal({
        title: 'Warning!',
        text: ' Are you sure you want to delete this?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Delete!',
        cancelButtonText: 'No, Cancel',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-primary ml-1',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            this.toDeletedID = id
            this.deleteWorkFlowCategory()
          }
        })
    },
  },
  setup() {
    const showSearchBar = ref(false)
    const showFilterOptions = ref(false)
    const WORKFLOW_CATEGORY_APP_STORE_MODULE_NAME = 'app-workflow-categories'

    // Register module
    if (!store.hasModule(WORKFLOW_CATEGORY_APP_STORE_MODULE_NAME)) store.registerModule(WORKFLOW_CATEGORY_APP_STORE_MODULE_NAME, workFlowCategoryStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(WORKFLOW_CATEGORY_APP_STORE_MODULE_NAME)) store.unregisterModule(WORKFLOW_CATEGORY_APP_STORE_MODULE_NAME)
    })

    const statusOptions = [
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ]

    const { canViewThisAction } = useAclUtils()

    const {
      fetchWorkFlowCategories,
      tableColumns,
      perPage,
      currentPage,
      totalWorkFlowCategories,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refWorkFlowCategoriesTable,
      refetchData,

      toDeletedID,
      deleteWorkFlowCategory,
      currentDataLength,

      // UI
      resolveWorkFlowCategoryStatusVariant,

      // Extra Filters
      statusFilter,
    } = useWorkFlowCategoriesList()

    return {

      // Sidebar

      fetchWorkFlowCategories,
      tableColumns,
      perPage,
      currentPage,
      totalWorkFlowCategories,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refWorkFlowCategoriesTable,
      refetchData,
      showSearchBar,
      showFilterOptions,
      toDeletedID,
      deleteWorkFlowCategory,
      currentDataLength,

      // Filter
      avatarText,
      canViewThisAction,

      // UI
      resolveWorkFlowCategoryStatusVariant,

      statusOptions,

      // Extra Filters
      statusFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
